import { forwardRef, InputGroup } from '@chakra-ui/react';

import * as Form from 'components/_core/form';

import locales from './locales';

interface SearchBarProps extends Omit<Form.InputProps, 'onChange'> {
  onChange: (searchText: string) => void;
}

const SearchBar = forwardRef<SearchBarProps, 'input'>(
  (
    { children, onChange, placeholder = locales.placeholder, ...props },
    ref,
  ) => (
    <InputGroup isolation="isolate">
      <Form.Input
        {...props}
        leftIcon="search"
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        ref={ref}
      />

      {children}
    </InputGroup>
  ),
);

export default SearchBar;
